import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { backgrounds, colors, fonts } from '../theme';
import { labelStyle } from '../styles';
import { fitFontSize } from '../text';
const formatDate = (date) => {
    const parsed = new Date(`${date}T00:00:00`);
    if (Number.isNaN(parsed.getTime()))
        return date;
    return parsed.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
};
export function IdleView({ event }) {
    return (_jsxs("div", Object.assign({ style: {
            position: 'absolute',
            inset: 0,
            background: backgrounds.day,
            boxSizing: 'border-box',
            padding: '52px 120px 72px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 56,
        } }, { children: [_jsx("div", Object.assign({ style: { fontFamily: fonts.logo, fontSize: 120, lineHeight: 1 } }, { children: "Dark side Mafia" })), _jsxs("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', gap: 20 } }, { children: [_jsx("div", Object.assign({ style: labelStyle }, { children: formatDate(event.date) })), _jsx("div", Object.assign({ style: {
                            fontFamily: fonts.serif,
                            fontStyle: 'italic',
                            fontWeight: 500,
                            fontSize: fitFontSize(event.name, 160, 18),
                            lineHeight: 1,
                        } }, { children: event.name }))] })), _jsx("div", Object.assign({ style: { fontSize: 34, color: colors.soft } }, { children: "\u0421\u043A\u043E\u0440\u043E \u043D\u0430\u0447\u043D\u0451\u0442\u0441\u044F \u0438\u0433\u0440\u0430" }))] })));
}
